import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { DistrictLookupRequest } from "./DistrictLookupRequest";

@Injectable()
export class DataService_DistrictLookup {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	DistrictLookup(parms: DistrictLookupRequest) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/DistrictLookup";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PersonTypeSelectList() {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/PersonTypeSelectList?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PersonGetPhotoByPhotoDataID(PersonPhotoDataID) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/PersonGetPhotoByPhotoDataID?PersonPhotoDataID=" + PersonPhotoDataID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DistrictLookupGetColumns() {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/DistrictLookupGetColumns?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
